// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FeIQn","right":"styles_right__20mBp"};